import { useContext } from 'react';

import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';

import { MAIN_CONTAINER_ID } from '../../constants';
import { DeviceContext } from '../../contexts';
import { ButtonTitleWithLoading } from '../ButtonTitleWithLoading';
import { AppTextField } from '../inputs/AppTextField';

export const ChatChangeNameDialog = ({
  open,
  handleClose,
  loading,
  confirmFunction,
  chatName,
  setChatName,
}: {
  open: boolean;
  handleClose: () => void;
  loading: boolean;
  confirmFunction: () => void;
  chatName: string;
  setChatName: (chatName: string) => void;
}) => {
  const { isMobile } = useContext(DeviceContext);

  return (
    <Dialog
      container={document.getElementById(MAIN_CONTAINER_ID)}
      fullScreen={isMobile}
      maxWidth="xs"
      fullWidth
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>Change chat name</DialogTitle>

      <DialogContent>
        <AppTextField
          label="Chat name"
          value={chatName}
          onChange={e => setChatName(e.target.value)}
          fullWidth
        />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>

        <Button
          style={{ width: 130 }}
          disabled={loading || !chatName}
          onClick={confirmFunction}
          color="primary"
          variant="contained"
        >
          <ButtonTitleWithLoading title="Save changes" loaderVariant="paper" loading={loading} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
